module.exports = __webpack_public_path__ + "files/7cad8dd1cfa8f8faf30301d8f5e1fc8f.svg";